export enum PlanCleanupMode {
  OlderThanMonth = 0,
  OlderThanYear = 1,
  OlderThanDate = 2,
}
